import api from "@/lib/api";
import { toast } from "sonner";

export async function downloadCsv(path, filename) {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success("Download started");
  } catch {
    toast.error("Could not export right now");
  }
}
